export default "__VITE_ASSET__DW84$F6C__"